export const RAC_SETTINGS_FORM_PREFIX = 'racSettingsForm';

export const RAC_SETTINGS_FIELDS_NAMES = {
  RATE_SHEET: `${RAC_SETTINGS_FORM_PREFIX}.rateSheet`,
  REGION: `${RAC_SETTINGS_FORM_PREFIX}.region`,
  TAX_RATE: `${RAC_SETTINGS_FORM_PREFIX}.taxRate`,
};
